import { connect } from "react-redux";

import AdminUsers, {
  IAdminUsersProps,
  IAdminUsersActions
} from "./admin-users";
import { navigateTo } from "../../home";
import { getUsers } from "../admin.actions";

export default connect(
  ({ admin }: any): IAdminUsersProps => {
    const { users, totalUsers } = admin;
    return {
      users,
      totalUsers
    };
  },
  (dispatch): IAdminUsersActions => ({
    editUser: userId => dispatch(navigateTo(`/admin/user/${userId}`)),
    getUsers: (skip, searchText, activeOnly, sort, reverse) =>
      dispatch(getUsers(skip, searchText, activeOnly, sort, reverse))
  })
)(AdminUsers);
